import React from 'react';

import { useTranslation, Trans } from 'react-i18next';

interface InstallStepsProps {
  onDownload: () => void;
}

export const InstallSteps: React.FC<InstallStepsProps> = ({ onDownload }) => {
  const { t } = useTranslation('pleri/onboarding');

  return (
    <div className="mx-auto mb-4 max-w-md rounded-lg bg-gradient-to-br from-[#FF732E]/5 to-[#E65A1F]/5 p-6">
      <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
        {t('manualInstallationSteps')}
      </h3>
      <ol className="space-y-4 text-left">
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            1
          </span>
          <div className="flex flex-col gap-2">
            <span className="text-gray-700 dark:text-gray-300">
              {t('downloadTheExtension')}
            </span>
            <button
              onClick={onDownload}
              className="group relative flex w-full items-center justify-center rounded-lg border-2 border-[#FF732E] bg-white px-4 py-2 text-sm font-medium text-[#FF732E] transition-all hover:bg-[#FF732E]/5 dark:bg-gray-900"
            >
              <span>{t('downloadExtension')}</span>
              <svg
                className="ml-2 h-4 w-4 transform transition-transform group-hover:translate-y-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
              </svg>
            </button>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            2
          </span>
          <span className="text-gray-700 dark:text-gray-300">
            <Trans
              t={t}
              i18nKey="unzipTheDownloadedPleriLatestChromeZip"
              components={{
                code: (
                  <code className="rounded bg-gray-100 px-1 py-0.5 text-sm dark:bg-gray-800" />
                ),
              }}
            />
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            3
          </span>
          <span className="text-gray-700 dark:text-gray-300">
            <Trans
              t={t}
              i18nKey="openChromeAndGoToChromeExtensions"
              components={{
                code: (
                  <code className="rounded bg-gray-100 px-1 py-0.5 text-sm dark:bg-gray-800" />
                ),
              }}
            />
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            4
          </span>
          <span className="text-gray-700 dark:text-gray-300">
            {t('enableDeveloperModeInTheTopRight')}
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            5
          </span>
          <span className="text-gray-700 dark:text-gray-300">
            {t('clickLoadUnpackedAndSelectTheUnzipped')}
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            6
          </span>
          <span className="text-gray-700 dark:text-gray-300">
            {t('theExtensionShouldNowAppearInYourChromeToolbar')}
          </span>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#FF732E] text-sm font-medium text-white">
            7
          </span>
          <span className="text-gray-700 dark:text-gray-300">
            {t('clickTheExtensionIconToAccessPleri')}
          </span>
        </li>
      </ol>
    </div>
  );
};
